import { combineReducers } from "redux"
import { contactListingReducer } from "./contact/reducers"
import { serialNumberListingReducer } from "./serial-numbers/reducers"


const combinedReducers = combineReducers({
    serialNumbers: serialNumberListingReducer,
    contacts: contactListingReducer,
})

export {
    combinedReducers
}



// WEBPACK FOOTER //
// ./src/state/listing/rootReducer.ts